import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton } from "@utils/extra-style";
import { leadStatusForList } from "@utils/filterOptions";

const LeadStatus = (props) => {
  const { t, data } = props;

  const colorArray = { 0: "#0A4986", 1: "#474747", 2: "#F08046", 4: "#32A728" };

  return (
    <>
      <ColumnButton
        border={colorArray[data.status]}
        background={colorArray[data.status]}
        marginRight="10px"
      >
        {t(leadStatusForList[data.status])}
      </ColumnButton>
    </>
  );
};

LeadStatus.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LeadStatus);
